import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { FormBody } from '../style';
import PropTypes from 'prop-types';
import { update_address } from '../redux/reducer';
import { useSelector, useDispatch } from 'react-redux';
import csc from 'country-state-city';
import { getUser } from '@app/auth/redux/selectors';
import { getCreating } from '../redux/selectors';
import commaNumber from 'comma-number';

const EditAddress = ({ data, id, selectedLocation, locations }) => {
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const loading = useSelector(getCreating);
  const [selectedCountry, setSelectedCountry] = useState(data.country);
  const [selectedState, setSelectedState] = useState(data.state);
  const countries = csc.getAllCountries();
  const [states, setStates] = useState([]);
  const [countryCode, setCountryCode] = useState('160');

  useEffect(() => {
    if (countryCode !== '') {
      const state = csc.getStatesOfCountry(countryCode);
      setStates(state);
    }
  }, [countryCode]);

  const initialValues = {
    street_address: data?.street_address,
    lga: data?.lga,
    city: data?.city,
    country: data?.country,
    state: data?.state,
    phone: data?.phone,
    full_name: data?.full_name || `${user?.first_name} ${user?.last_name}`,
  };

  const handleSubmit = (values) => {
    const updatedData = {
      ...values,
      country: selectedCountry || data.country,
      state: selectedState || data.state,
    };
    dispatch(update_address({ id, data: updatedData }));
  };

  const handleCountryChange = (e) => {
    const selectedCountry = JSON.parse(e.target.value);
    setSelectedCountry(selectedCountry.name);
    setCountryCode(selectedCountry.id);
  };

  const handleStateChange = (e) => {
    const selectedState = JSON.parse(e.target.value);
    setSelectedState(selectedState.name);
  };

  return (
    <FormBody>
      <div className="box">
        <p className="heading">Edit address</p>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, handleChange }) => (
            <Form>
              <div className="form_container">
                <label className="input_heading">Address</label>
                <input
                  type="text"
                  placeholder="Street Address"
                  name="street_address"
                  value={values.street_address}
                  onChange={handleChange}
                />
              </div>
              <div className="select_form_container">
                <div className="first__select">
                  <label className="input_heading">Country</label>
                  <select name="country" onChange={handleCountryChange}>
                    <option value="">--Select Country--</option>
                    {countries.map((country) => (
                      <option
                        key={country.id}
                        value={JSON.stringify(country)}
                        selected={country.name === data?.country}
                      >
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="first__select">
                  <label className="input_heading">State</label>

                  <select name="state" onChange={handleStateChange}>
                    <option value="">--Select State--</option>
                    {states.map((state) => (
                      <option
                        key={state.id}
                        value={JSON.stringify(state)}
                        selected={state.name === data?.state}
                      >
                        {state.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="select_form_container">
                <div className="first__select">
                  <label className="input_heading">Delivery Area</label>

                  <select
                    name="lga"
                    value={values.lga || selectedLocation.location}
                    onChange={handleChange}
                  >
                    <option value="">--Select Area--</option>
                    {locations.map((data) => (
                      <option
                        key={data.id}
                        value={data.location}
                        selected={data.location === selectedLocation?.location}
                      >
                        {`${data.location} - ${
                          data.price_bike.currency.symbol
                        }${commaNumber(data.price_bike.value)}`}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="first__select">
                  <label className="input_heading">Phone Number</label>
                  <input
                    type="text"
                    placeholder="Enter Phone Number"
                    name="phone"
                    value={values.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <button className="form__button" type="submit" disabled={loading}>
                {loading ? 'Saving...' : 'Save Addresses'}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </FormBody>
  );
};

export default EditAddress;

EditAddress.propTypes = {
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  locations: PropTypes.array,
  selectedLocation: PropTypes.object,
};

EditAddress.defaultProps = {
  locations: [],
  selectedLocation: {},
};
